/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ULTIMATE FIX: Override product-images component before it even initializes
  
  // Store reference to original customElements.define
  const originalDefine = customElements.define;
  let componentOverridden = false;
  
  // Override customElements.define to intercept product-images registration
  customElements.define = function(name, constructor, options) {
    if (name === 'product-images' && !componentOverridden) {
      // Create our patched version of the ProductImages class
      class InstantProductImages extends constructor {
        constructor() {
          super();
          this._instantFixApplied = true;
        }
        
        connectedCallback() {
          // Run original connectedCallback but disable transitions immediately
          super.connectedCallback();
          
          // Apply instant fix right after connection
          this.applyInstantFix();
        }
        
        setActiveMedia(id) {
          if (!id) return;
          
          this.setAttribute('data-active-media', id);
          
          const allSlides = this.querySelectorAll('.product__slide');
          const selectedImage = this.querySelector(`[data-media-id="${id}"]`);
          const selectedImageFocus = selectedImage?.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          const deferredMedia = selectedImage?.querySelector('deferred-media');
          
          // Force instant state changes on ALL slides
          allSlides.forEach(slide => {
            // Force inline styles to override any CSS
            slide.style.cssText += 'transition: none !important; animation: none !important;';

            // Force all images within slides to be visible immediately
            const images = slide.querySelectorAll('img');
            images.forEach(img => {
              img.style.cssText += 'opacity: 1 !important; visibility: visible !important; transition: none !important; animation: none !important;';
              img.classList.remove('is-loading');
            });

            if (slide === selectedImage) {
              slide.classList.remove('media--hiding', 'media--hidden');
              slide.classList.add('media--active');
              slide.style.cssText += 'opacity: 1 !important; visibility: visible !important; position: relative !important; z-index: 1 !important;';
            } else {
              slide.classList.remove('media--active', 'media--hiding');
              slide.classList.add('media--hidden');
              slide.style.cssText += 'opacity: 0 !important; visibility: hidden !important; position: absolute !important; z-index: 0 !important;';
            }
          });
          
          // Force media loading if slide becomes visible
          if (deferredMedia && deferredMedia.getAttribute('loaded') !== 'true') {
            selectedImage.querySelector('[data-deferred-media-button]')?.dispatchEvent(new Event('click', {bubbles: false}));
          }
          
          // Update height instantly
          const mediaHeight = selectedImage?.offsetHeight || this.productMediaItems?.[0]?.offsetHeight;
          if (mediaHeight) {
            this.style.setProperty('--height', `${mediaHeight}px`);
          }
          
          // Move focus to the selected media
          if (document.body.classList.contains('is-focused')) {
            selectedImageFocus?.focus();
          }
        }
        
        productMediaObserver() {
          // Disable the transition observer completely
          return;
        }
        
        applyInstantFix() {
          // Apply instant fix to all slides immediately
          const allSlides = this.querySelectorAll('.product__slide');
          allSlides.forEach(slide => {
            slide.style.cssText += 'transition: none !important; animation: none !important;';

            // Force all images within slides to be visible immediately
            const images = slide.querySelectorAll('img');
            images.forEach(img => {
              img.style.cssText += 'opacity: 1 !important; visibility: visible !important; transition: none !important; animation: none !important;';
              img.classList.remove('is-loading');
            });

            // Block all transition events
            const events = ['transitionstart', 'transitionrun', 'transitionend', 'transitioncancel', 'animationstart', 'animationend', 'animationcancel'];
            events.forEach(eventType => {
              slide.addEventListener(eventType, function(e) {
                e.stopPropagation();
                e.stopImmediatePropagation();
                return false;
              }, true);
            });
          });
        }
      }
      
      // Register our patched version
      originalDefine.call(this, name, InstantProductImages, options);
      componentOverridden = true;
      return;
    }
    
    // For all other components, use original define
    return originalDefine.call(this, name, constructor, options);
  };
  
  // Fallback: If component is already defined, patch existing instances
  function patchExistingInstances() {
    const productImagesElements = document.querySelectorAll('product-images');
    
    productImagesElements.forEach(productImages => {
      if (productImages._instantFixApplied) return;
      
      // Store original methods
      const originalSetActiveMedia = productImages.setActiveMedia;
      const originalProductMediaObserver = productImages.productMediaObserver;
      
      // Override setActiveMedia
      productImages.setActiveMedia = function(id) {
        if (!id) return;
        
        this.setAttribute('data-active-media', id);
        
        const allSlides = this.querySelectorAll('.product__slide');
        const selectedImage = this.querySelector(`[data-media-id="${id}"]`);
        const selectedImageFocus = selectedImage?.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const deferredMedia = selectedImage?.querySelector('deferred-media');
        
          // Force instant state changes on ALL slides
          allSlides.forEach(slide => {
            slide.style.cssText += 'transition: none !important; animation: none !important;';

            // Force all images within slides to be visible immediately
            const images = slide.querySelectorAll('img');
            images.forEach(img => {
              img.style.cssText += 'opacity: 1 !important; visibility: visible !important; transition: none !important; animation: none !important;';
              img.classList.remove('is-loading');
            });

            if (slide === selectedImage) {
              slide.classList.remove('media--hiding', 'media--hidden');
              slide.classList.add('media--active');
              slide.style.cssText += 'opacity: 1 !important; visibility: visible !important; position: relative !important; z-index: 1 !important;';
            } else {
              slide.classList.remove('media--active', 'media--hiding');
              slide.classList.add('media--hidden');
              slide.style.cssText += 'opacity: 0 !important; visibility: hidden !important; position: absolute !important; z-index: 0 !important;';
            }
          });
        
        // Force media loading if slide becomes visible
        if (deferredMedia && deferredMedia.getAttribute('loaded') !== 'true') {
          selectedImage.querySelector('[data-deferred-media-button]')?.dispatchEvent(new Event('click', {bubbles: false}));
        }
        
        // Update height instantly
        const mediaHeight = selectedImage?.offsetHeight || this.productMediaItems?.[0]?.offsetHeight;
        if (mediaHeight) {
          this.style.setProperty('--height', `${mediaHeight}px`);
        }
        
        // Move focus to the selected media
        if (document.body.classList.contains('is-focused')) {
          selectedImageFocus?.focus();
        }
      };
      
      // Disable productMediaObserver
      productImages.productMediaObserver = function() {
        return;
      };
      
      // Apply instant styles to all existing slides and images
      const allSlides = productImages.querySelectorAll('.product__slide');
      allSlides.forEach(slide => {
        slide.style.cssText += 'transition: none !important; animation: none !important;';

        // Force all images within slides to be visible immediately
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          img.style.cssText += 'opacity: 1 !important; visibility: visible !important; transition: none !important; animation: none !important;';
          img.classList.remove('is-loading');
        });
      });
      
      productImages._instantFixApplied = true;
    });
  }
  
  // Apply fallback immediately and continuously
  patchExistingInstances();
  document.addEventListener('DOMContentLoaded', patchExistingInstances);
  
  // Watch for new instances
  const observer = new MutationObserver(() => {
    patchExistingInstances();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Global event interceptor to catch any remaining transitions
  ['transitionstart', 'transitionrun', 'transitionend', 'transitioncancel', 'animationstart', 'animationend', 'animationcancel'].forEach(eventType => {
    document.addEventListener(eventType, function(e) {
      if (e.target.closest('product-images')) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    }, true);
  });

  // IMMEDIATE: Force all product images to be visible on page load
  (function forceImmediateImageVisibility() {
    const forceVisible = () => {
      // Force all product images to be immediately visible
      const productImages = document.querySelectorAll('product-images');
      productImages.forEach(container => {
        const allSlides = container.querySelectorAll('.product__slide');
        const allImages = container.querySelectorAll('img');

        // Force slides
        allSlides.forEach(slide => {
          slide.style.cssText += 'transition: none !important; animation: none !important;';
          if (slide.classList.contains('media--active')) {
            slide.style.cssText += 'opacity: 1 !important; visibility: visible !important; position: relative !important; z-index: 1 !important;';
          } else {
            slide.style.cssText += 'opacity: 0 !important; visibility: hidden !important; position: absolute !important; z-index: 0 !important;';
          }
        });

        // Force all images
        allImages.forEach(img => {
          img.style.cssText += 'opacity: 1 !important; visibility: visible !important; transition: none !important; animation: none !important;';
          img.classList.remove('is-loading');
          img.removeAttribute('loading'); // Remove lazy loading attribute
        });
      });
    };

    // Run immediately
    forceVisible();

    // Run again after a short delay to catch any dynamically loaded content
    setTimeout(forceVisible, 100);
    setTimeout(forceVisible, 500);
    setTimeout(forceVisible, 1000);
  })();

  // Invert swipe direction on mobile for RTL languages
  (function enableRtlSwipeInversion() {
    const isRTL = (document.documentElement.getAttribute('dir') || document.dir || '').toLowerCase() === 'rtl';
    if (!isRTL) return;

    const onReady = (fn) => (document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn));

    const applyPatch = (el) => {
      if (el.__rtlPatched) return;
      if (!el.showNextImage || !el.showPreviousImage) return;
      el.__originalNext = el.showNextImage.bind(el);
      el.__originalPrev = el.showPreviousImage.bind(el);
      // Swap methods so all triggers (drag, arrows, keys) are RTL-intuitive
      el.showNextImage = el.__originalPrev;
      el.showPreviousImage = el.__originalNext;
      el.__rtlPatched = true;
    };

    const removePatch = (el) => {
      if (!el.__rtlPatched) return;
      if (el.__originalNext && el.__originalPrev) {
        el.showNextImage = el.__originalNext;
        el.showPreviousImage = el.__originalPrev;
      }
      el.__rtlPatched = false;
    };

    const patchGridSliderButtons = (root = document) => {
      root.querySelectorAll('grid-slider').forEach((el) => {
        try {
          if (el.__rtlGridPatched) return;
          const prevBtn = el.querySelector('[data-button-prev]');
          const nextBtn = el.querySelector('[data-button-next]');
          if (!prevBtn || !nextBtn) return;

          // Swap DOM attributes so the existing click handler logic inverts
          prevBtn.removeAttribute('data-button-prev');
          prevBtn.setAttribute('data-button-next', '');
          nextBtn.removeAttribute('data-button-next');
          nextBtn.setAttribute('data-button-prev', '');

          // Swap instance refs so disabled-state logic stays correct
          if (el.buttonPrev && el.buttonNext) {
            const tmp = el.buttonPrev;
            el.buttonPrev = el.buttonNext;
            el.buttonNext = tmp;
          }

          el.__rtlGridPatched = true;
        } catch (e) {
          // noop
        }
      });
    };

    const update = () => {
      document.querySelectorAll('product-images').forEach((el) => {
        applyPatch(el);
      });
      patchGridSliderButtons();
    };

    onReady(update);
    document.addEventListener('theme:resize:width', update);
  })();

// Translate hCaptcha disclaimer to Arabic when site language is Arabic
if (/^ar\b/i.test(document.documentElement.lang)) {
  const translateHcaptchaDisclaimer = (root = document) => {
    // Find hCaptcha privacy/terms links
    const privacyLinks = root.querySelectorAll('a[href*="hcaptcha.com/privacy"]');
    const termsLinks   = root.querySelectorAll('a[href*="hcaptcha.com/terms"]');

    // Collect possible containers holding the two links
    const containers = new Set();
    privacyLinks.forEach(a => containers.add(a.closest('p,small,div,span') || a.parentElement));
    termsLinks.forEach(a => containers.add(a.closest('p,small,div,span') || a.parentElement));

    containers.forEach(container => {
      if (!container || container.dataset.hcaptchaLocalized === 'true') return;
      const privacy = container.querySelector('a[href*="hcaptcha.com/privacy"]');
      const terms   = container.querySelector('a[href*="hcaptcha.com/terms"]');
      if (!privacy || !terms) return;

      // Set Arabic link texts
      privacy.textContent = 'سياسة الخصوصية';
      terms.textContent   = 'شروط الخدمة';

      // Rebuild the sentence in Arabic while preserving the links
      const pClone = privacy.cloneNode(true);
      const tClone = terms.cloneNode(true);

      container.innerHTML = '';
      container.append(
        document.createTextNode('هذا الموقع محمي بواسطة hCaptcha وتطبّق '),
        pClone,
        document.createTextNode(' و'),
        tClone
      );

      container.style.direction = 'rtl';
      container.style.textAlign = 'right';
      container.dataset.hcaptchaLocalized = 'true';
    });
  };

  const onReady = fn => (document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn));
  onReady(() => {
    translateHcaptchaDisclaimer(document);
    // Handle dynamically injected disclaimers
    const obs = new MutationObserver(muts => {
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1) {
            if (n.querySelector?.('a[href*="hcaptcha.com/privacy"]') || n.querySelector?.('a[href*="hcaptcha.com/terms"]')) {
              translateHcaptchaDisclaimer(n);
            }
          }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  });
}
  


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



